import { updateSalesType } from "../../../../../actions/Utilities/SalesType";
import { useMutation } from "react-query";

const useUpdateSalesType = () => {
  return useMutation(updateSalesType);
};
export default useUpdateSalesType;
